<template>
  <div class="auth-list-box-2-wrap">
    <div class="line-1">
      <el-checkbox-group v-model="check_data" @change="data_change">
        <el-checkbox :label="box_data.right_id" >{{ box_data.label }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        box_data: {}
      },
      data() {
        return {
          check_data: []
        }
      },
      mounted() {
        this.init_data();
      },
      watch: {
        "box_data.check"(val) {
          this.init_data();
        }
      },
      methods: {
        init_data() {
          console.log('this.box_data', this.box_data)
          if (this.box_data.check) {
            this.check_data.push(this.box_data.right_id);
          } else {
            this.check_data = [];
          }
        },
        data_change(val) {
          this.$emit("check_change", this.Get_Data());
        },
        Get_Data() {
          let _temp = {
            right_id: this.box_data.right_id,
            entity: this.box_data.current_entity,
            check: false
          };
          if (this.check_data.length != 0) {
            _temp.check = true;
            return _temp;
          } else {
            return _temp;
          }
        }
      },
    }
</script>

<style lang="scss">
  .auth-list-box-1-wrap {
    display: flex;
    position: relative;
    flex-direction: column;

    .line-1 {
      flex: 0 0 auto;
      display: flex;
      margin: 5px 0 5px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// authList_box_1.vue?d0a7d98a